export default {
  reg: {
    letter: 'Nur englische Buchstaben und Leerzeichen sind erlaubt',
  },
}
